import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en_translations from './languages/en';
import de_translations from './languages/de';
import es_translations from './languages/es';
import fr_translations from './languages/fr';
import it_translations from './languages/it';
import ja_translations from './languages/ja';
import ko_translations from './languages/ko';
import nl_translations from './languages/nl';
import pl_translations from './languages/pl';
import po_translations from './languages/po';
import th_translations from './languages/th';
import tr_translations from './languages/tr';
import vi_translations from './languages/vi';
import zhcmn_translations from './languages/zhcmn';
import zhzho_translations from './languages/zhzho';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: en_translations,
      de: de_translations,
      es: es_translations,
      fr: fr_translations,
      it: it_translations,
      ja: ja_translations,
      ko: ko_translations,
      nl: nl_translations,
      pl: pl_translations,
      po: po_translations,
      th: th_translations,
      tr: tr_translations,
      vi: vi_translations,
      'zh-TW': zhcmn_translations,
      'zh-CN': zhzho_translations,
    },
    fallbackLng: 'en',
    debug: true,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
